export const GET_SNAPSHOTS = 'GET_SNAPSHOTS';
export const GET_SNAPSHOTS_SUCCESS = 'GET_SNAPSHOTS_SUCCESS';
export const GET_SNAPSHOTS_FAILURE = 'GET_SNAPSHOTS_FAILURE';
export const DELETE_SNAPSHOT = 'DELETE_SNAPSHOT';
export const DELETE_SNAPSHOT_SUCCESS = 'DELETE_SNAPSHOT_SUCCESS';
export const ADD_TO_SNAPSHOTS = 'ADD_TO_SNAPSHOTS';
export const LOAD_MORE_SNAPSHOTS = 'LOAD_MORE_SNAPSHOTS';
export const LOAD_MORE_SNAPSHOTS_SUCCESS = 'LOAD_MORE_SNAPSHOTS_SUCCESS';
